import {
  NativeAppStatus,
  VIDEO_NATIVE_APP_ID,
  PROTECT_NATIVE_APP_ID,
} from 'utils/nativeApps';

import { getOpParams } from '../getOpParams';

import { useAwareDeploymentUrl } from './useAwareDeploymentUrl';
import { useFeatureFlag } from './useFeatureFlag';
import { useOpQuery } from './useOpQuery';

// Unification only means Aware - does not include DMP
export const useIsUnificationEnabled = () => {
  const { orgId } = getOpParams();
  /**
   * This defines the future of unification. Both the existance of Video and Protect
   * Napps (native apps) are essentially saying we have a deployment syncing data with Helium
   */
  const { data: isVideoOrProtectEnabled, isLoading: isLoadingOrgNativeApps } =
    useOpQuery({
      apiEndpointName: 'listOrgNativeApps',
      parameters: [orgId],
      select: (res) => {
        const napps = res.json?.data || [];
        return napps?.some(
          (app) =>
            [VIDEO_NATIVE_APP_ID, PROTECT_NATIVE_APP_ID].includes(
              app.nativeAppId,
            ) && app.status === NativeAppStatus.Active,
        );
      },
    });

  const { value: enabledOrgIds, isLoading: isLoadingFF } = useFeatureFlag<
    number[]
  >('ORG_IDS_WITH_UNIFICATION_ENABLED', orgId);

  const orgHasFF = enabledOrgIds?.includes(Number(orgId));

  const awareDeploymentUrl = useAwareDeploymentUrl();

  if (isLoadingOrgNativeApps || isLoadingFF || awareDeploymentUrl === null) {
    return null;
  }

  const isSyncing = orgHasFF || isVideoOrProtectEnabled;

  return Boolean(isSyncing && awareDeploymentUrl);
};
